import { Component, Vue ,Watch} from 'vue-property-decorator'
import moment from "moment";
import { cropList } from "@/types/Component";
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';
import { LoginUser } from "@/types/Component";
import ReferencePlantingModal from '@/assets/common/Modal/ReferencePlantingListModal/ReferencePlantingListModal.vue';
import WorkerGoalRegister from '@/assets/common/Modal/WorkerGoalRegisterModal/WorkerGoalRegisterModal.vue';
import ProductivityGraphModal from '@/assets/common/Modal/ProductivityGraphModal/ProductivityGraphModal.vue';

interface GoalTitle {
    id: number;
    title: string;
}

@Component({
    components: {
        EmptyGraphMessage,
        ReferencePlantingModal,
        WorkerGoalRegister,
        ProductivityGraphModal
    }
})

export default class WorkerGoalList extends Vue {
    isDropdownVisible = false;
    screen = 'WORKERGOALLIST';
    private list: any | null = null
    baseUrl = '/admin/worker_goal_list';
    selectScreenManagement = '/graphScreenManagement';
    cropDetails = [] as cropList;
    selectedStartDate: string | Date = new Date();
    selectedEndDate: string | Date = new Date();
    startDate: string | Date = new Date();
    endDate: string | Date = new Date();
    private workerGoalsList =  [] as any[];
    private selectedAgriFieldId : string | null = null;
    private selectedPlantingId : string | null = null;
    private selectedWorkItemId : string | null = null;
    private selectedCropId : string | null = null;
    private selectedTitleId : string | null = null;
    private isButtonDisabled = false;
    private agriFields = [] as any[];
    private plantings = [] as any[];
    private goalTitles = [] as any[];
    private workItems = [] as any[];
    private selectedPlantingName = '';
    private selectedAgriFieldName = '';
    private selectedWorkItemName = '';
    private selectedWorkerName = '';
    private isSpinnerLoading = false;
    private isShow = false;
    private isRefresh = false;
    private mode = '';
    private isWorkRecordPopup = '';
    private recordDate = '';
    private isPlantingShow = false
    includeHiddenFlag = false
    searchQuery = '';
    private selectedWorkerGoalId = '';
    private sortOrder = true;

    
    private showProductivityGraphModal = false;    

    get isAdmin(): boolean {
        return this.loginUser.role.find((r: string) => {
            return r === 'ADMIN'
        }) !== undefined;
      }
    
    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    }

    get workerGoalListModalOpen():boolean{
        return(
            this.isShow ||
            this.showProductivityGraphModal
        )
    }

    private created() {
        const currentDate = new Date();
        this.selectedStartDate = moment(currentDate).startOf('month').format('YYYY-MM-DD');
        this.selectedEndDate = moment(currentDate).endOf('month').format('YYYY-MM-DD');
        this.startDate = this.selectedStartDate;
        this.endDate = this.selectedEndDate;
        this.getTitles();
        this.getWorkerGoalList();
        this.getAgriFields();
        this.getPlantings();
        this.getWorkItems();
        this.getCrops();
    }

    get filteredGoalTitles() {
        if (!this.searchQuery) {
          return this.goalTitles;
        }
        return this.goalTitles.filter(goalTitle =>
          goalTitle.title.includes(this.searchQuery)
        );
    }

      selectTitle(goalTitle: any) {
        this.searchQuery = goalTitle.title;
        this.isDropdownVisible = false;
      }
    
      hideDropdown() {
        setTimeout(() => {
          this.isDropdownVisible = false;
        }, 200);
      }


  filterDropdown() {
    this.isDropdownVisible = true;
  }
 
    getWorkerGoalList() {
        this.$apiClient.doRequest('get', `${this.baseUrl}`).then(res => {
        setTimeout(() => {
            this.isSpinnerLoading = false;
            }, 500);
          this.workerGoalsList = res.goalList
          if(res.selectedItems!=null){
            this.searchQuery = res.selectedItems.titleName
            this.selectedCropId = res.selectedItems.cropId
            this.selectedAgriFieldId = res.selectedItems.agriFieldId
            this.selectedPlantingId = res.selectedItems.plantingId
            this.selectedWorkItemId = res.selectedItems.workItemId
            this.selectedStartDate = res.selectedItems.displayFromDate ? res.selectedItems.displayFromDate : ""
            this.selectedEndDate = res.selectedItems.displayToDate ? res.selectedItems.displayToDate : ""
            this.startDate = res.selectedItems.displayFromDate ? res.selectedItems.displayFromDate : ""
            this.endDate = res.selectedItems.displayToDate ? res.selectedItems.displayToDate : ""
            this.includeHiddenFlag = res.selectedItems.includeHiddenFlag
            if ((this.selectedStartDate > this.selectedEndDate) || (this.selectedStartDate === '' && this.selectedEndDate === '') || (this.selectedStartDate === '' && this.selectedEndDate !== '') 
                || (this.selectedStartDate !== '' && this.selectedEndDate === '')) {
                this.isButtonDisabled = true;
                this.workerGoalsList = [];
            } else {
                this.isButtonDisabled = false;
            }
          }
        })
    }

    clearSearchQuery(){
        this.searchQuery= '';
    }
    
    handleSelectChange(flag = true) {
        this.selectedPlantingName = this.plantings.find(item=>item.id==this.selectedPlantingId)?.name
        this.selectedAgriFieldName = this.agriFields.find(item=>item.id==this.selectedAgriFieldId)?.name
        this.selectedWorkItemName = this.workItems.find(item=>item.id==this.selectedWorkItemId)?.name
        if(this.searchQuery.trim().length > 255){
            window.alert(`タイトルは255文字以内で入力してください（現在は${this.searchQuery.trim().length}文字）`)
            return false
        }
        const params = {
          titleName:this.searchQuery.trim(),
          cropId: this.selectedCropId,
          plantingId: this.selectedPlantingId,
          agriFieldId: this.selectedAgriFieldId,
          selectedWorkId: this.selectedWorkItemId,
          startDate: this.selectedStartDate,
          endDate: this.selectedEndDate,
          screenName: this.screen,
          includeHiddenFlag: this.includeHiddenFlag
        }
        this.$apiClient.doRequest('post', `${this.selectScreenManagement}`,params).then(res => {
            if (flag) {
                this.refreshTable();
            }
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
        })
    } 

    validateDates() {
        if (!this.selectedStartDate || !this.selectedEndDate) return;
        if (this.selectedStartDate > this.selectedEndDate) {
          this.selectedStartDate = this.startDate;
          this.selectedEndDate = this.endDate;
          this.isButtonDisabled = true;
        } else {
          this.isButtonDisabled = false;
          this.startDate = this.selectedStartDate;
          this.endDate = this.selectedEndDate;
        }
    }

    getAgriFields() {
        this.$apiClient.doRequest('get','/agri_fields?with_hidden=true').then((res) => {
        this.agriFields = res.agri_fields
        this.selectedAgriFieldName = this.agriFields.find(item=>item.id==this.selectedAgriFieldId)?.name
        })
    }

    getPlantings() {
        this.$apiClient.doRequest('get','/plantings?with_hidden=true').then((res) => {
        this.plantings = res.plantings.sort((a:any,b:any) => a.name.localeCompare(b.name))
        this.selectedPlantingName = this.plantings.find(item=>item.id==this.selectedPlantingId)?.name
       })
    }

    getCrops() {
        this.$apiClient.doRequest("get", `/crops/cropBytenentId`).then(res => {
            this.cropDetails = res.crops;
            this.cropDetails.sort((a:any, b:any) => a.name.localeCompare(b.name));
        });
    }

    getWorkItems() {
        this.$apiClient.doRequest('get','/work_items?with_hidden=true').then((res) => {
        this.workItems = res.work_items
        this.selectedWorkItemName = this.workItems.find(item=>item.id==this.selectedWorkItemId)?.name
        })
    }

    getTitles() {
        this.$apiClient.doRequest('get','/admin/worker_goal_list/title').then((res) => {
        this.goalTitles = res.goal_tiles;
        })
    }

    private convertDate(date: Date): string {
        if (date) {
            const d = new Date(date);
            return `${d.getFullYear()}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}`;
        }
        return "-";
    }

    dateNavigation(action: string) {
        if (!this.selectedStartDate || !this.selectedEndDate) return;
        this.validateDates()
        if(this.isButtonDisabled == false){
        const updateDate = (date: moment.MomentInput, offset: moment.DurationInputArg1, unit: moment.unitOfTime.Base) => moment(date).add(offset, unit).format('YYYY-MM-DD');
        const daysDifference = moment(this.selectedEndDate).diff(this.selectedStartDate, 'days')+1;
        const offset = (action === 'previous') ? -daysDifference : daysDifference;
        this.selectedStartDate = updateDate(this.selectedStartDate, offset, 'days');
        this.selectedEndDate = updateDate(this.selectedEndDate, offset, 'days');
        this.startDate = this.selectedStartDate;
        this.endDate = this.selectedEndDate;
        this.handleSelectChange();
        } else {
            this.isButtonDisabled = false
        }
    }

    refreshTable () {
        this.workerGoalsList = []
        this.isSpinnerLoading = true
        this.goalTitles = []
        this.getTitles();
        this.getWorkerGoalList();
    }

    
    get filterAgriFields() {
        return this.includeHiddenFlag ? this.agriFields : this.agriFields.filter(a => this.selectedAgriFieldId == a.id || !a.is_hidden);
    }  
    
    get filterWorkItems() {
        return this.includeHiddenFlag ? this.workItems : this.workItems.filter(wi => this.selectedWorkItemId == wi.id || !wi.is_hidden);
    } 

    get filteredPlantings() {
        if (this.selectedCropId === null) {
            return this.includeHiddenFlag ? this.plantings : this.plantings.filter(p => this.selectedPlantingId == p.id || !p.is_hidden);
        } else {
            return this.includeHiddenFlag ? this.plantings.filter(p => p.crop.id === this.selectedCropId) : this.plantings.filter(p => this.selectedPlantingId == p.id || (!p.is_hidden && p.crop.id === this.selectedCropId));
        }
    }

    handleCropSelect() {
        this.selectedPlantingId = null
    }

    handlePlantingSelect() {
        if (this.selectedPlantingId != null) {
            const selectedPlanting = this.plantings.find(p => p.id === this.selectedPlantingId);
            if (selectedPlanting) {
                this.selectedCropId = selectedPlanting.crop.id;
            }
        }
    }

    closeGoalRegisterModal() {
        this.selectedWorkerGoalId = '';
        this.isShow = false;
        this.$root.$emit('header-inert', false);
        this.$emit('worker-goal-inert', false);
    }

    openWorkerGoalRegistrationModal(id = '',mode = ''){
        this.selectedWorkerGoalId = id;
        this.mode = mode;
        this.isShow = true;
        this.$root.$emit('header-inert', true);
        this.$emit('worker-goal-inert', true);
    }

    openGraphModal(obj: any): void {
        const params = {
            cropId: obj.cropId,
            plantingId: obj.plantingId,
            agriFieldId: obj.agriFieldId,
            selectedWorkId: obj.workItemId,
            startDate: obj.cultivationStartDate || obj.workStartDate,
            endDate: obj.cultivationEndDate|| obj.workEndDate,
            workUnitId: obj.workUnitId,
            screenName: "PRODUCTIVITYGRAPH",
        }
        this.$apiClient.doRequest('post', `/graphScreenManagement`,params).then(res => {
            this.showProductivityGraphModal = true;
            this.$root.$emit('header-inert', true);
            this.$emit('worker-goal-inert', true);
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
        })
    }

    closeGraphModal(): void {
        this.showProductivityGraphModal = false
        this.$root.$emit('header-inert', false);
        this.$emit('worker-goal-inert', false);
    }

    private sort(fieldName: string): void {
        this.sortOrder = !this.sortOrder;
        this.workerGoalsList.sort((a, b) => {
            const aValue = a[fieldName];
            const bValue = b[fieldName];
            if (aValue === null && bValue === null) return 0;
            if (aValue === null) return 1;
            if (bValue === null) return -1;
            if (typeof aValue === 'string' && typeof bValue === 'string') 
                return this.sortOrder ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
            if (typeof aValue === 'number' && typeof bValue === 'number') 
                return this.sortOrder ? aValue - bValue : bValue - aValue;
            return this.sortOrder ? String(aValue).localeCompare(String(bValue)) : String(bValue).localeCompare(String(aValue));
        });
     }

     buttonValidation(){
        if((this.selectedStartDate > this.selectedEndDate) || (this.selectedStartDate === '' && this.selectedEndDate === '') || (this.selectedStartDate === '' && this.selectedEndDate !== '') 
            || (this.selectedStartDate !== '' && this.selectedEndDate === '')){
            this.isButtonDisabled = true;
        } else {
            this.isButtonDisabled = false;
        }
      }
}

